(function () {
  const THRESHOLD = 95000;

  function formatMoney(cents) {
    return '$' + (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function updateBar(bar, totalCents) {
    var remaining = Math.max(0, THRESHOLD - totalCents);
    var progress = Math.min(100, (totalCents / THRESHOLD) * 100);
    var achieved = totalCents >= THRESHOLD;

    bar.classList.toggle('free-shipping-bar--achieved', achieved);

    var iconSvg = achieved
      ? '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>'
      : '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';

    var messageClass = achieved
      ? 'free-shipping-bar__message free-shipping-bar__message--achieved'
      : 'free-shipping-bar__message';

    var messageText = achieved
      ? 'Tienes envio gratis'
      : 'Te faltan <strong>' + formatMoney(remaining) + '</strong> para envio gratis';

    bar.innerHTML =
      '<div class="free-shipping-bar__content">' +
        '<div class="free-shipping-bar__icon">' + iconSvg + '</div>' +
        '<div class="free-shipping-bar__text">' +
          '<p class="' + messageClass + '">' + messageText + '</p>' +
        '</div>' +
      '</div>' +
      '<div class="free-shipping-bar__track">' +
        '<div class="free-shipping-bar__fill" style="width: ' + progress + '%;"></div>' +
      '</div>';
  }

  function updateAllBars(totalCents) {
    document.querySelectorAll('.free-shipping-bar').forEach(function (bar) {
      updateBar(bar, totalCents);
    });
  }

  function fetchAndUpdate() {
    fetch(window.Shopify.routes.root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateAllBars(cart.total_price); })
      .catch(function () {});
  }

  var debounceTimer;
  function debouncedFetchAndUpdate() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(fetchAndUpdate, 150);
  }

  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    if (typeof url === 'string' && (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1 || url.indexOf('/cart/clear') !== -1)) {
      return origFetch.apply(this, arguments).then(function (response) {
        debouncedFetchAndUpdate();
        return response;
      });
    }
    return origFetch.apply(this, arguments);
  };
})();
